import { StateCreator } from 'zustand';

import {
  BonanzaPromoStatus,
  getBonanzaStaticData,
} from '@/helpers/bonanzaPromo';
import { Locale } from '@/helpers/languages';
import { BonanzaPromoState, CommonStoreType } from '@/store/commonStore/types';

export const useBonanzaPromoSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  BonanzaPromoState
> = () => {
  return {
    userBonanzaGroup: BonanzaPromoStatus.LEVEL_0,
    bonanzaReward: '',
    bonanzaStaticData: getBonanzaStaticData(Locale.ENGLISH)[
      BonanzaPromoStatus.LEVEL_0
    ],
    isBonanzaPromoAvailable: true,
  };
};
